import {
  IBrand,
  IInvoice,
  IMarketingCampaignStep,
  IOrganisation,
  IPatient,
  IPatientViewInvoiceTokenData,
} from '@principle-theorem/principle-core/interfaces';
import {
  DocumentReference,
  getDoc,
  getParentDocRef,
  WithRef,
} from '@principle-theorem/shared';
import * as moment from 'moment-timezone';
import { createCSRF } from '@principle-theorem/temporary-tokens';
import { Organisation } from '../organisation/organisation';

export async function generateViewInvoiceToken(
  org: WithRef<IOrganisation>,
  invoice: WithRef<IInvoice>,
  campaignStepSource?: DocumentReference<IMarketingCampaignStep>
): Promise<string> {
  const tokenExpiry = moment().add(30, 'day');
  const tokenData: IPatientViewInvoiceTokenData = {
    invoice: invoice.ref,
    campaignStepSource,
  };
  const csrf = await createCSRF(
    Organisation.temporaryTokenCol(org),
    tokenData,
    tokenExpiry,
    moment(tokenExpiry).add(1, 'week'),
    true
  );

  return csrf.tokenUid;
}

export async function generateViewInvoiceUrl(
  invoice: WithRef<IInvoice>,
  appUrl: string
): Promise<string> {
  const patientRef = getParentDocRef<IPatient>(invoice.ref.path);
  const brandRef = getParentDocRef<IBrand>(patientRef.path);
  const orgRef = getParentDocRef<IOrganisation>(brandRef.path);
  const token = await generateViewInvoiceToken(await getDoc(orgRef), invoice);

  return [appUrl, 'invoice', token].join('/');
}
